import { render, staticRenderFns } from "./screenshot-loader.vue?vue&type=template&id=7826829c&"
import script from "./screenshot-loader.vue?vue&type=script&lang=js&"
export * from "./screenshot-loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports